 /*-----quick view box section css start------*/
 document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rug-quick-btn');
    if (!btn) return;

    e.preventDefault();

    const modal = document.getElementById('rugQuickModal');

    document.getElementById('rug-qv-title').innerText = btn.dataset.title || '';
    document.getElementById('rug-qv-price').innerText = btn.dataset.price ||'';
    document.getElementById('rug-qv-size').innerText =
      btn.dataset.size ? 'Available Sizes: ' + btn.dataset.size : '';
    document.getElementById('rug-qv-desc').innerText = btn.dataset.desc || '';
    document.getElementById('rug-qv-link').href = btn.dataset.url || '#';

    modal.classList.add('active');
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.classList.contains('rug-modal-close') ||
      e.target.id === 'rugQuickModal'
    ) {
      document.getElementById('rugQuickModal').classList.remove('active');
    }
  });
/*-----quick view box section css end------*/

/*-----search bar js start------*/
document.addEventListener('click', function (e) {
  const searchBtn = e.target.closest('.custom_header_search .search__button');
  if (!searchBtn) return;

  const wrapper = searchBtn.closest('.custom_header_search');
  const input = wrapper.querySelector('.search__input');

  // ❌ preventDefault only when closed
  if (!wrapper.classList.contains('search-open')) {
    e.preventDefault(); // first click open karega
    wrapper.classList.add('search-open');

    if (input) input.focus();
  }
});
// Optional: click outside to close
document.addEventListener('click', function (e) {
  const wrapper = document.querySelector('.custom_header_search');
  if (!wrapper) return;

  if (!wrapper.contains(e.target)) {
    wrapper.classList.remove('search-open');
  }
});

/*-----search bar js end------*/

/*-----Inventory search bar js start------*/
document.addEventListener("DOMContentLoaded", async () => {
  const COLLECTION_HANDLE = "search-results"; // changed
  const PER_PAGE = 30;
  const CACHE_KEY = "rug_products_cache_search_results_v1";
  const CACHE_TIME_KEY = "rug_products_cache_time_search_results_v1";
  const CACHE_HOURS = 6;

  const els = {
    widthMin: document.getElementById("widthMin"),
    widthMax: document.getElementById("widthMax"),
    lengthMin: document.getElementById("lengthMin"),
    lengthMax: document.getElementById("lengthMax"),
    widthMinVal: document.getElementById("widthMinVal"),
    widthMaxVal: document.getElementById("widthMaxVal"),
    lengthMinVal: document.getElementById("lengthMinVal"),
    lengthMaxVal: document.getElementById("lengthMaxVal"),
    viewBtn: document.getElementById("viewResultsBtn"),
    liveCount: document.getElementById("liveResultCount"),
    noResults: document.getElementById("noResultsMsg"),
    grid: document.getElementById("product-grid"),
    defaultPagination: document.querySelector(".pagination-wrapper")
  };

  /* ===============================
     LABELS
  =============================== */
/* ===============================
   LABELS + FEET / METER
=============================== */
const FT_TO_M = 0.3048;
let currentUnit = "feet";

const unitRadios = document.querySelectorAll('input[name="unit"]');
const widthLabel = document.getElementById("widthLabel");
const lengthLabel = document.getElementById("lengthLabel");

function convertValue(value) {
  const num = Number(value);

  return currentUnit === "meter"
    ? (num * FT_TO_M).toFixed(2)
    : num;
}
function updateRangeMask(minEl, maxEl) {
  const min = Number(minEl.value);
  const max = Number(maxEl.value);

  const minLimit = Number(minEl.min);
  const maxLimit = Number(minEl.max);
  const step = Number(minEl.step || 1);

  const totalSteps = (maxLimit - minLimit) / step;

  const startStep = (min - minLimit) / step;
  const endStep = (max - minLimit) / step;

  const minPercent = (startStep / totalSteps) * 100;
  const maxPercent = (endStep / totalSteps) * 100;

  const wrapper = minEl.closest(".range-wrapper");
  if (!wrapper) return;

  wrapper.style.setProperty("--min", `${minPercent}%`);
  wrapper.style.setProperty("--max", `${maxPercent}%`);
}

function clampRanges(minEl, maxEl) {
  let minVal = Number(minEl.value);
  let maxVal = Number(maxEl.value);

  if (minVal > maxVal) {
    minEl.value = maxVal;
  }
}


function updateLabels() {
  if (!els.widthMin) return;

  if (els.widthMinVal) els.widthMinVal.textContent = convertValue(els.widthMin.value);
  if (els.widthMaxVal) els.widthMaxVal.textContent = convertValue(els.widthMax.value);
  if (els.lengthMinVal) els.lengthMinVal.textContent = convertValue(els.lengthMin.value);
  if (els.lengthMaxVal) els.lengthMaxVal.textContent = convertValue(els.lengthMax.value);

  if (widthLabel) {
    widthLabel.textContent =
      currentUnit === "meter" ? "Width (Meter)" : "Width (ft)";
  }

  if (lengthLabel) {
    lengthLabel.textContent =
      currentUnit === "meter" ? "Length (Meter)" : "Length (ft)";
  }
  updateRangeMask(els.widthMin, els.widthMax);
  updateRangeMask(els.lengthMin, els.lengthMax);
  updateSelectedWidthLive();
  updateSelectedLengthLive();
   
  //April 30, 2026
  setThumbPosition(els.widthMin, els.widthMinVal);
  setThumbPosition(els.widthMax, els.widthMaxVal);
  setThumbPosition(els.lengthMin, els.lengthMinVal);
  setThumbPosition(els.lengthMax, els.lengthMaxVal);

  

}
//April 30, 2026
function setThumbPosition(input, label) {
  if (!input || !label) return;

  const min = input.min;
  const max = input.max;
  const val = input.value;

  const percent = ((val - min) / (max - min)) * 100;


  label.style.left = percent + "%";
}

// [els.widthMin, els.widthMax, els.lengthMin, els.lengthMax].forEach(el => {
//   el?.addEventListener("input", updateLabels);
// });

[els.widthMin, els.widthMax].forEach(el => {
  el?.addEventListener("input", () => {
    clampRanges(els.widthMin, els.widthMax);
    updateLabels();
    applyFilter();
  });
});

[els.lengthMin, els.lengthMax].forEach(el => {
  el?.addEventListener("input", () => {
    clampRanges(els.lengthMin, els.lengthMax);
    updateLabels();
    applyFilter();
  });
});

unitRadios.forEach(radio => {
  radio.addEventListener("change", function () {
    currentUnit = this.value;
    updateLabels();
  });
});

const selectedWidthLive = document.getElementById("selectedWidthLive");


function updateSelectedWidthLive() {
  if (!selectedWidthLive) return;

  const wMin = els.widthMin.value;
  const wMax = els.widthMax.value;

  if (currentUnit === "meter") {
    selectedWidthLive.innerHTML =
      `${convertValue(wMin)}m x ${convertValue(wMax)}m`;
  } else {
    selectedWidthLive.innerHTML =
      `${wMin}ft x ${wMax}ft`;
  }
}
const selectedLengthLive = document.getElementById("selectedLengthLive");
function updateSelectedLengthLive() {
  if (!selectedLengthLive) return;

  const lMin = els.lengthMin.value;
  const lMax = els.lengthMax.value;

  if (currentUnit === "meter") {
    selectedLengthLive.innerHTML =
      `${convertValue(lMin)}m x ${convertValue(lMax)}m`;
  } else {
    selectedLengthLive.innerHTML =
      `${lMin}ft x ${lMax}ft`;
  }
}

updateLabels();

  /* ===============================
     VIEW RESULT BUTTON
  =============================== */
  els.viewBtn?.addEventListener("click", () => {
    const params = new URLSearchParams({
      wmin: els.widthMin?.value || 0,
      wmax: els.widthMax?.value || 30,
      lmin: els.lengthMin?.value || 0,
      lmax: els.lengthMax?.value || 50
    });

    window.location.href = `/collections/${COLLECTION_HANDLE}?${params.toString()}`;
  });

  /* ===============================
     ONLY RUN ON SEARCH RESULTS COLLECTION
  =============================== */
  const isTargetCollection =
    window.location.pathname === "/collections/search-results" ||
    window.location.pathname === "/collections/search-results/";

  if (!isTargetCollection || !els.grid) return;
if (window.innerWidth <= 768) return;
  if (els.defaultPagination) {
    els.defaultPagination.style.display = "none";
  }

  /* ===============================
     URL PARAMS
  =============================== */
  const params = new URLSearchParams(window.location.search);

  if (params.has("wmin")) els.widthMin.value = params.get("wmin");
  if (params.has("wmax")) els.widthMax.value = params.get("wmax");
  if (params.has("lmin")) els.lengthMin.value = params.get("lmin");
  if (params.has("lmax")) els.lengthMax.value = params.get("lmax");

  updateLabels();

  /* ===============================
     CUSTOM PAGINATION
  =============================== */
  let pager = document.getElementById("customPagination");

  if (!pager) {
    pager = document.createElement("div");
    pager.id = "customPagination";
    pager.className = "custom-pagination";
    els.grid.parentNode.appendChild(pager);
  }

 function showLoading(msg = "Please wait while we search results......") {
  if (els.noResults) {
    els.noResults.style.display = "none";
  }

els.grid.innerHTML = `
<div class="please_wait_div_filter" style="
display:block;
width:100%;
padding:12px 15px;
background:#290356;
color:#ffffff;
font-size:21px;
line-height:1.4;
text-align:left;
border-radius:4px;
box-sizing:border-box;
grid-column:1 / -1;
">
${msg}
</div>`;
}

  /* ===============================
     CACHE
  =============================== */
  function getCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      const time = localStorage.getItem(CACHE_TIME_KEY);

      if (!raw || !time) return null;

      const age = (Date.now() - Number(time)) / (1000 * 60 * 60);
      if (age > CACHE_HOURS) return null;

      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function setCache(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());
    } catch (e) {}
  }

  /* ===============================
     FETCH ALL PRODUCTS
  =============================== */
  let allProducts = [];

 async function fetchAllProducts() {
  const cached = getCache();

  if (cached && cached.length) {
    allProducts = cached;
    return;
  }

  showLoading("Please wait while we search results...");

  let temp = [];
  let page = 1;
  let hasMore = true;
  const BATCH_SIZE = 5; // 5 pages at once

  while (hasMore) {
    const requests = [];

    for (let i = 0; i < BATCH_SIZE; i++) {
      requests.push(
        fetch(`/collections/${COLLECTION_HANDLE}?page=${page + i}`)
          .then(res => res.ok ? res.text() : null)
          .catch(() => null)
      );
    }

    const responses = await Promise.all(requests);

    let foundInBatch = false;

    responses.forEach(html => {
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, "text/html");
      const cards = doc.querySelectorAll("#product-grid li.grid__item");

      if (cards.length) {
        foundInBatch = true;

        cards.forEach(card => {
          temp.push({
            html: card.outerHTML,
            width: Number(card.dataset.rugWidth || 0),
            length: Number(card.dataset.rugLength || 0)
          });
        });
      }
    });

    if (!foundInBatch) {
      hasMore = false;
    }

    page += BATCH_SIZE;
  }

  allProducts = temp;

  if (allProducts.length > 0) {
    setCache(temp);
  } else {
    els.grid.innerHTML = "";
    if (els.noResults) els.noResults.style.display = "block";
  }
}

  /* ===============================
     FILTER
  =============================== */
  let filtered = [];
  let currentPage = 1;

  function applyFilter() {
    const wMin = +els.widthMin.value;
    const wMax = +els.widthMax.value;
    const lMin = +els.lengthMin.value;
    const lMax = +els.lengthMax.value;

    filtered = allProducts.filter(item =>
      item.width >= wMin &&
      item.width <= wMax &&
      item.length >= lMin &&
      item.length <= lMax
    );

    if (els.liveCount) els.liveCount.textContent = filtered.length;

    if (els.noResults) {
      els.noResults.style.display = filtered.length ? "none" : "block";
    }

    renderPage(1);
  }

  /* ===============================
     RENDER PAGE
  =============================== */
  function renderPage(page) {
    currentPage = page;

    const start = (page - 1) * PER_PAGE;
    const end = start + PER_PAGE;

    const pageItems = filtered.slice(start, end);
    els.grid.innerHTML = pageItems.map(item => item.html).join("");

    renderPagination(Math.ceil(filtered.length / PER_PAGE));
  }

  /* ===============================
     PAGINATION
  =============================== */
function renderPagination(totalPages) {
  pager.innerHTML = "";

  if (totalPages <= 1) {
    pager.style.display = "none";
    return;
  }

  pager.style.display = "block";
  pager.className = "pagination-wrapper";

  let pages = [];

  // Always first page
  pages.push(1);

  if (currentPage <= 2) {
    for (let i = 2; i <= Math.min(4, totalPages - 1); i++) {
      pages.push(i);
    }
    if (totalPages > 4) pages.push("dots");
  }

  else if (currentPage === 3 || currentPage === 4) {
    for (let i = 2; i <= Math.min(6, totalPages - 1); i++) {
      pages.push(i);
    }
    if (totalPages > 6) pages.push("dots");
  }

  else {
    pages.push("dots");

    for (
      let i = currentPage - 2;
      i <= Math.min(currentPage + 2, totalPages - 1);
      i++
    ) {
      if (i > 1) pages.push(i);
    }

    if (currentPage + 2 < totalPages - 1) {
      pages.push("dots2");
    }
  }

  // Always last page
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  pages = [...new Set(pages)];

  let html = `
    <nav class="pagination" role="navigation" aria-label="Pagination">
      <ul class="pagination__list list-unstyled" role="list">
  `;

  // PREV button
  if (currentPage > 1) {
    html += `
      <li>
        <a href="javascript:void(0)" class="pagination__item prev-btn">❮</a>
      </li>
    `;
  }

  pages.forEach(p => {
    if (String(p).includes("dots")) {
      html += `
        <li>
          <span class="pagination__item">...</span>
        </li>
      `;
    } else {
      html += `
        <li>
          <a href="javascript:void(0)"
             class="pagination__item ${
               p === currentPage ? "pagination__item--current light" : ""
             }"
             data-page="${p}">
            ${p}
          </a>
        </li>
      `;
    }
  });

  // NEXT button
  if (currentPage < totalPages) {
    html += `
      <li>
        <a href="javascript:void(0)" class="pagination__item next-btn">❯</a>
      </li>
    `;
  }

  html += `</ul></nav>`;
  pager.innerHTML = html;

  // Page click
  pager.querySelectorAll("[data-page]").forEach(btn => {
    btn.addEventListener("click", () => {
      renderPage(+btn.dataset.page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });

  // Prev click
  const prev = pager.querySelector(".prev-btn");
  if (prev) {
    prev.addEventListener("click", () => {
      renderPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // Next click
  const next = pager.querySelector(".next-btn");
  if (next) {
    next.addEventListener("click", () => {
      renderPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
}

  /* ===============================
     INIT
  =============================== */
  await fetchAllProducts();
  applyFilter();

  [els.widthMin, els.widthMax, els.lengthMin, els.lengthMax].forEach(el => {
    el?.addEventListener("input", applyFilter);
  });
});


/*-----Inventory search bar for mobile js start------*/

document.addEventListener("DOMContentLoaded", async () => {
  const COLLECTION_HANDLE = "search-results";
  const PER_PAGE = 30;
  const CACHE_KEY = "mobile_rug_products_cache_v1";
  const CACHE_TIME_KEY = "mobile_rug_products_cache_time_v1";
  const CACHE_HOURS = 6;

  const els = {
    widthMin: document.getElementById("mobileWidthMin"),
    widthMax: document.getElementById("mobileWidthMax"),
    lengthMin: document.getElementById("mobileLengthMin"),
    lengthMax: document.getElementById("mobileLengthMax"),
    widthMinVal: document.getElementById("mobileWidthMinVal"),
    widthMaxVal: document.getElementById("mobileWidthMaxVal"),
    lengthMinVal: document.getElementById("mobileLengthMinVal"),
    lengthMaxVal: document.getElementById("mobileLengthMaxVal"),
    viewBtn: document.getElementById("mobileViewResultsBtn"),
    liveCount: document.getElementById("mobileLiveResultCount"),
    noResults: document.getElementById("noResultsMsg"),
    grid: document.getElementById("product-grid"),
    defaultPagination: document.querySelectorAll(".pagination-wrapper")
  };

  const FT_TO_M = 0.3048;
  let currentUnit = "feet";
  const unitRadios = document.querySelectorAll('input[name="unit"]');

  function convertValue(value) {
    const num = Number(value);
    return currentUnit === "meter" ? (num * FT_TO_M).toFixed(2) : num;
  }

  function updateRangeMask(minEl, maxEl) {
    const min = Number(minEl.value), max = Number(maxEl.value);
    const minLimit = Number(minEl.min), maxLimit = Number(minEl.max);
    const step = Number(minEl.step || 1);
    const totalSteps = (maxLimit - minLimit) / step;
    const minPercent = (((min - minLimit) / step) / totalSteps) * 100;
    const maxPercent = (((max - minLimit) / step) / totalSteps) * 100;
    const wrapper = minEl.closest('.range-wrapper');
    if (!wrapper) return;
    wrapper.style.setProperty('--min', `${minPercent}%`);
    wrapper.style.setProperty('--max', `${maxPercent}%`);
  }

  function clampRanges(minEl, maxEl) {
  let minVal = Number(minEl.value);
  let maxVal = Number(maxEl.value);

  if (minVal > maxVal) {
    minEl.value = maxVal;
  }
} 

  function updateLabels() {
    if (!els.widthMin) return;
    els.widthMinVal.textContent = convertValue(els.widthMin.value);
    els.widthMaxVal.textContent = convertValue(els.widthMax.value);
    els.lengthMinVal.textContent = convertValue(els.lengthMin.value);
    els.lengthMaxVal.textContent = convertValue(els.lengthMax.value);
    updateRangeMask(els.widthMin, els.widthMax);
    updateRangeMask(els.lengthMin, els.lengthMax);
    updateSelectedWidthLive();
    updateSelectedLengthLive();

     //April 30, 2026
  setThumbPosition(els.widthMin, els.widthMinVal);
  setThumbPosition(els.widthMax, els.widthMaxVal);
  setThumbPosition(els.lengthMin, els.lengthMinVal);
  setThumbPosition(els.lengthMax, els.lengthMaxVal);

  }

  //April 30, 2026
function setThumbPosition(input, label) {
  if (!input || !label) return;

  const min = input.min;
  const max = input.max;
  const val = input.value;

  const percent = ((val - min) / (max - min)) * 100;


  label.style.left = percent + "%";
}

  // [els.widthMin, els.widthMax, els.lengthMin, els.lengthMax].forEach(el => {
  //   el?.addEventListener("input", updateLabels);
  // });

[els.widthMin, els.widthMax].forEach(el => {
  el?.addEventListener("input", () => {
    clampRanges(els.widthMin, els.widthMax);
    updateLabels();
    applyFilter();
  });
});

[els.lengthMin, els.lengthMax].forEach(el => {
  el?.addEventListener("input", () => {
    clampRanges(els.lengthMin, els.lengthMax);
    updateLabels();
    applyFilter();
  });
});


  unitRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      currentUnit = this.value;
      updateLabels();
    });
  });

const selectedWidthLive = document.getElementById("mobileselectedWidthLive");


function updateSelectedWidthLive() {
  if (!selectedWidthLive) return;

  const wMin = els.widthMin.value;
  const wMax = els.widthMax.value;

  if (currentUnit === "meter") {
    selectedWidthLive.innerHTML =
      `${convertValue(wMin)}m x ${convertValue(wMax)}m`;
  } else {
    selectedWidthLive.innerHTML =
      `${wMin}ft x ${wMax}ft`;
  }
}
const selectedLengthLive = document.getElementById("mobileselectedLengthLive");
function updateSelectedLengthLive() {
  if (!selectedLengthLive) return;

  const lMin = els.lengthMin.value;
  const lMax = els.lengthMax.value;

  if (currentUnit === "meter") {
    selectedLengthLive.innerHTML =
      `${convertValue(lMin)}m x ${convertValue(lMax)}m`;
  } else {
    selectedLengthLive.innerHTML =
      `${lMin}ft x ${lMax}ft`;
  }
}
  updateLabels();

  els.viewBtn?.addEventListener("click", () => {
    const params = new URLSearchParams({
      wmin: els.widthMin.value,
      wmax: els.widthMax.value,
      lmin: els.lengthMin.value,
      lmax: els.lengthMax.value
    });
    window.location.href = `/collections/${COLLECTION_HANDLE}?${params.toString()}`;
  });

  const isTargetCollection = window.location.pathname.includes(`/collections/${COLLECTION_HANDLE}`);
  if (!isTargetCollection || !els.grid) return;

  if (window.innerWidth > 768) return;

  els.defaultPagination.forEach(el => {
  el.style.display = "none";
});

  const params = new URLSearchParams(window.location.search);
  if (params.has("wmin")) els.widthMin.value = params.get("wmin");
  if (params.has("wmax")) els.widthMax.value = params.get("wmax");
  if (params.has("lmin")) els.lengthMin.value = params.get("lmin");
  if (params.has("lmax")) els.lengthMax.value = params.get("lmax");
  updateLabels();

  let pager = document.getElementById("mobileCustomPagination");
  if (!pager) {
    pager = document.createElement("div");
    pager.id = "mobileCustomPagination";
    pager.className = "pagination-wrapper";
    els.grid.parentNode.appendChild(pager);
  }

  function showLoading(msg = "Please wait while we search results...") {
    if (els.noResults) els.noResults.style.display = "none";
    els.grid.innerHTML = `<div style="padding:8px 10px;background:#290356;color:#fff;">${msg}</div>`;
  }

  function getCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      const time = localStorage.getItem(CACHE_TIME_KEY);
      if (!raw || !time) return null;
      const age = (Date.now() - Number(time)) / (1000 * 60 * 60);
      if (age > CACHE_HOURS) return null;
      return JSON.parse(raw);
    } catch (e) { return null; }
  }

  function setCache(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());
    } catch (e) {}
  }

  let allProducts = [];
  let filtered = [];
  let currentPage = 1;

  async function fetchAllProducts() {
    const cached = getCache();
    if (cached && cached.length) {
      allProducts = cached;
      return;
    }

    showLoading();
    let temp = [];
    let page = 1;
    let hasMore = true;
    const BATCH_SIZE = 5;

    while (hasMore) {
      const requests = [];
      for (let i = 0; i < BATCH_SIZE; i++) {
        requests.push(fetch(`/collections/${COLLECTION_HANDLE}?page=${page + i}`).then(r => r.ok ? r.text() : null).catch(() => null));
      }
      const responses = await Promise.all(requests);
      let found = false;

      responses.forEach(html => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const cards = doc.querySelectorAll("#product-grid li.grid__item");
        if (cards.length) {
          found = true;
          cards.forEach(card => {
            temp.push({
              html: card.outerHTML,
              width: Number(card.dataset.rugWidth || 0),
              length: Number(card.dataset.rugLength || 0)
            });
          });
        }
      });

      if (!found) hasMore = false;
      page += BATCH_SIZE;
    }

    allProducts = temp;
    if (allProducts.length) setCache(temp);
    else {
      els.grid.innerHTML = "";
      if (els.noResults) els.noResults.style.display = "block";
    }
  }

  function applyFilter() {
    const wMin = +els.widthMin.value, wMax = +els.widthMax.value;
    const lMin = +els.lengthMin.value, lMax = +els.lengthMax.value;

    filtered = allProducts.filter(item => item.width >= wMin && item.width <= wMax && item.length >= lMin && item.length <= lMax);

    if (els.liveCount) els.liveCount.textContent = filtered.length;
    if (els.noResults) els.noResults.style.display = filtered.length ? "none" : "block";
    renderPage(1);
  }

  function renderPage(page) {
    currentPage = page;
    const start = (page - 1) * PER_PAGE;
    const pageItems = filtered.slice(start, start + PER_PAGE);
    els.grid.innerHTML = pageItems.map(item => item.html).join("");
    renderPagination(Math.ceil(filtered.length / PER_PAGE));
  }

  // function renderPagination(totalPages) {
  //   pager.innerHTML = "";
  //   if (totalPages <= 1) return;

  //   let html = '<nav class="pagination"><ul class="pagination__list list-unstyled">';
  //   for (let i = 1; i <= totalPages; i++) {
  //     html += `<li><a href="javascript:void(0)" class="pagination__item ${i === currentPage ? 'pagination__item--current light' : ''}" data-page="${i}">${i}</a></li>`;
  //   }
  //   html += '</ul></nav>';
  //   pager.innerHTML = html;

  //   pager.querySelectorAll('[data-page]').forEach(btn => {
  //     btn.addEventListener('click', () => renderPage(+btn.dataset.page));
  //   });
  // }

  function renderPagination(totalPages) {
  pager.innerHTML = "";

  if (totalPages <= 1) {
    pager.style.display = "none";
    return;
  }

  pager.style.display = "block";
  pager.className = "pagination-wrapper";

  let pages = [];

  // Always first page
  pages.push(1);

  if (currentPage <= 2) {
    for (let i = 2; i <= Math.min(4, totalPages - 1); i++) {
      pages.push(i);
    }
    if (totalPages > 4) pages.push("dots");
  }

  else if (currentPage === 3 || currentPage === 4) {
    for (let i = 2; i <= Math.min(6, totalPages - 1); i++) {
      pages.push(i);
    }
    if (totalPages > 6) pages.push("dots");
  }

  else {
    pages.push("dots");

    for (
      let i = currentPage - 2;
      i <= Math.min(currentPage + 2, totalPages - 1);
      i++
    ) {
      if (i > 1) pages.push(i);
    }

    if (currentPage + 2 < totalPages - 1) {
      pages.push("dots2");
    }
  }

  // Always last page
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  pages = [...new Set(pages)];

  let html = `
    <nav class="pagination" role="navigation" aria-label="Pagination">
      <ul class="pagination__list list-unstyled" role="list">
  `;

  // PREV button
  if (currentPage > 1) {
    html += `
      <li>
        <a href="javascript:void(0)" class="pagination__item prev-btn">❮</a>
      </li>
    `;
  }

  pages.forEach(p => {
    if (String(p).includes("dots")) {
      html += `
        <li>
          <span class="pagination__item">...</span>
        </li>
      `;
    } else {
      html += `
        <li>
          <a href="javascript:void(0)"
             class="pagination__item ${
               p === currentPage ? "pagination__item--current light" : ""
             }"
             data-page="${p}">
            ${p}
          </a>
        </li>
      `;
    }
  });

  // NEXT button
  if (currentPage < totalPages) {
    html += `
      <li>
        <a href="javascript:void(0)" class="pagination__item next-btn">❯</a>
      </li>
    `;
  }

  html += `</ul></nav>`;
  pager.innerHTML = html;

  // Page click
  pager.querySelectorAll("[data-page]").forEach(btn => {
    btn.addEventListener("click", () => {
      renderPage(+btn.dataset.page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });

  // Prev click
  const prev = pager.querySelector(".prev-btn");
  if (prev) {
    prev.addEventListener("click", () => {
      renderPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // Next click
  const next = pager.querySelector(".next-btn");
  if (next) {
    next.addEventListener("click", () => {
      renderPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
}
  await fetchAllProducts();
  applyFilter();

  [els.widthMin, els.widthMax, els.lengthMin, els.lengthMax].forEach(el => {
    el?.addEventListener("input", applyFilter);
  });
});

/*-----Inventory search bar for mobile js end------*/

// collection in Inventory search start
document.addEventListener("click", function (e) {
  const clickedToggle = e.target.closest(".collection_inventory_search-metafield");
  const allItems = document.querySelectorAll(".collection-item-metafield");


  if (clickedToggle) {
    e.preventDefault();
    e.stopPropagation();

    const parentItem = clickedToggle.closest(".collection-item-metafield");
    const isOpen = parentItem.classList.contains("active");


    allItems.forEach(item => item.classList.remove("active"));

    // toggle current
    if (!isOpen) {
      parentItem.classList.add("active");
    }

    return;
  }


  if (e.target.closest(".dropdown-collections")) {
    return;
  }

  allItems.forEach(item => item.classList.remove("active"));
});
// collection in Inventory search end



// decription read more 

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".read-more-btn");
  const shortDesc = document.querySelector(".desc-short");
  const fullDesc = document.querySelector(".desc-full");

  if (btn) {
    btn.addEventListener("click", function () {
      if (fullDesc.style.display === "none") {
        fullDesc.style.display = "block";
        shortDesc.style.display = "none";
        btn.innerText = "Read Less";
      } else {
        fullDesc.style.display = "none";
        shortDesc.style.display = "block";
        btn.innerText = "Read More";
      }
    });
  }
});


// for img on the product page 

document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll('.thumbnail-list__item button').forEach(function(button) {
    
    button.addEventListener("click", function(e) {
      e.preventDefault();

      const targetId = this.closest('.thumbnail-list__item').getAttribute("data-target");
      const targetSlide = document.querySelector('[data-media-id="' + targetId + '"]');

      if (targetSlide) {
        targetSlide.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

    });

  });

});



// custom  sort filter start April 18, 2026
let currentSort = localStorage.getItem("rugSortOrder") || "asc";
let isUserChanged = false;
let isSorting = false;
let firstSortDone = false;

// ---------------- PAGE GRID DETECT ----------------
function getGrid() {
  // Search Page
  if (document.body.classList.contains("search")) {
    return document.querySelector("#product-grid ul.product-grid");
  }

  // Collection Page
  if (document.body.classList.contains("collection")) {
    return document.querySelector(".collection #product-grid");
  }

  return null;
}

// ---------------- LOADER ----------------
function showSortLoader() {
  let loader = document.getElementById("sort-loader");

  if (!loader) {
    loader = document.createElement("div");
    loader.id = "sort-loader";
    loader.innerHTML = "Sorting products...";
    loader.style.cssText = `
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255,255,255,0.75);
      z-index: 99999;
      font-size: 16px;
      font-weight: 500;
    `;
    document.body.appendChild(loader);
  }

  loader.style.display = "flex";
}

function hideSortLoader() {
  const loader = document.getElementById("sort-loader");
  if (loader) loader.style.display = "none";
}

// ---------------- SORT FUNCTION ----------------
function sortProducts(order, silent = false) {
  const grid = getGrid();
  if (!grid || !order || isSorting) return;

  const cards = Array.from(grid.querySelectorAll(".grid__item"));
  if (!cards.length) return;

  isSorting = true;

  cards.sort((a, b) => {
    const aWidth = parseFloat(a.dataset.rugWidth) || 0;
    const bWidth = parseFloat(b.dataset.rugWidth) || 0;

    return order === "asc"
      ? aWidth - bWidth
      : bWidth - aWidth;
  });

  const frag = document.createDocumentFragment();
  cards.forEach(card => frag.appendChild(card));
  grid.appendChild(frag);

  setTimeout(() => {
    isSorting = false;
  }, 0);

  if (!silent) {
    const select = document.getElementById("width-sort");
    if (select) select.value = order;
  }
}

// ---------------- USER CHANGE ----------------
document.addEventListener("change", (e) => {
  if (e.target?.id === "width-sort") {
    currentSort = e.target.value;
    isUserChanged = true;

    localStorage.setItem("rugSortOrder", currentSort);

    if (!firstSortDone) {
      showSortLoader();

      requestAnimationFrame(() => {
        sortProducts(currentSort);
        hideSortLoader();
        firstSortDone = true;
      });
    } else {
      sortProducts(currentSort);
    }
  }
});

// ---------------- OBSERVER ----------------
const observer = new MutationObserver(() => {
  if (isSorting) return;
  if (!isUserChanged) return;

  requestAnimationFrame(() => {
    sortProducts(currentSort, true);
  });
});

// ---------------- INIT ----------------
document.addEventListener("DOMContentLoaded", () => {
  const gridContainer = document.querySelector("#ProductGridContainer");
  const select = document.getElementById("width-sort");

  if (!gridContainer) return;

  observer.observe(gridContainer, {
    childList: true,
    subtree: true
  });

  if (select) {
    select.value = currentSort;

    requestAnimationFrame(() => {
      sortProducts(currentSort, true);
      isUserChanged = true;
      firstSortDone = true;
    });
  }
});
// custom  sort filter end April 18, 2026


// inventory serch menu open close js start
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector("ul.mega-menu.mega-menu--shop");
  const content = document.querySelector(".mega-menu__content_custom");

  if (!menu) return;

  // Toggle menu only when clicking the top menu area
  menu.addEventListener("click", function (e) {
    // Ignore clicks inside dropdown content
    if (e.target.closest(".mega-menu__content_custom")) return;

    e.preventDefault();
    e.stopPropagation();
    menu.classList.toggle("active");
  });

  // Close menu when clicking outside
  document.addEventListener("click", function (e) {
    if (
      !menu.contains(e.target) &&
      !(content && content.contains(e.target))
    ) {
      menu.classList.remove("active");
    }
  });
});
// inventory serch menu open close js end

// contact for piricing April 28, 2026
// document.addEventListener("DOMContentLoaded", function () {
//   const params = new URLSearchParams(window.location.search);

//   const rugName = params.get("rug_name");
//   const rugNumber = params.get("rug_number");

//   const rugNameField = document.getElementById("ContactForm-rug-name");
//   const rugNumberField = document.getElementById("ContactForm-rug-number");

//   if (rugName && rugNameField) {
//     rugNameField.value = rugName;
//   }

//   if (rugNumber && rugNumberField) {
//     rugNumberField.value = rugNumber;
//   }
// });
// contact for piricing April 28, 2026


  document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    const rug = params.get("rug_url");

    if (rug) {
      document.getElementById("ContactForm-rug-link").value =
        window.location.origin + rug;
    }
  });

